import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../../../stateManagement/store';

const baseQuery = fetchBaseQuery({
    baseUrl: 'https://pkk.rosreestr.ru/api',
    prepareHeaders: (headers, { getState }) => {
        let token = (getState() as RootState).auth.tokens.app;
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
});

export const rosreestrAPI = createApi({
    reducerPath: 'rosreestrAPI',
    baseQuery: baseQuery,
    endpoints: (builder) => ({})
});

export const rosreestrAPIReducer = rosreestrAPI.reducer
export const resetRosreestrAPI = rosreestrAPI.util.resetApiState